var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14H5.875V14.75H7.125V14Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 14.75H4.625V15.5H5.875V14.75Z",
    fill: "#343434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 12.5H5.875V13.25H7.125V12.5Z",
    fill: "#343434"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 13.25H4.625V14H5.875V13.25Z",
    fill: "#343434"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 11H5.875V11.75H7.125V11Z",
    fill: "#343434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 11.75H4.625V12.5H5.875V11.75Z",
    fill: "#343434"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.5H5.875V10.25H7.125V9.5Z",
    fill: "#343434"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 10.25H4.625V11H5.875V10.25Z",
    fill: "#343434"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 8H5.875V8.75H7.125V8Z",
    fill: "#343434"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 8.75H4.625V9.5H5.875V8.75Z",
    fill: "#343434"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.625H5C4.8625 3.625 4.75 3.7375 4.75 3.875V7C4.75 7.1375 4.8625 7.25 5 7.25H7C7.1375 7.25 7.25 7.1375 7.25 7V3.875C7.25 3.7375 7.1375 3.625 7 3.625ZM6.625 5.625H5.375V4.25H6.625V5.625Z",
    fill: "#343434"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C11.3431 10 10 11.3431 10 13C10 14.6569 11.3431 16 13 16C14.6569 16 16 14.6569 16 13C16 11.3431 14.6569 10 13 10ZM14.3603 12.1235L14.3461 12.1455L13.3171 13.5752C13.2486 13.6835 13.1286 13.75 13 13.75C12.8714 13.75 12.7514 13.6835 12.683 13.5754L11.6397 12.1236C11.5736 12.0079 11.5742 11.8645 11.641 11.7494C11.7079 11.6341 11.8322 11.5626 11.9655 11.5626H12.5V10.75C12.5 10.5432 12.6683 10.375 12.875 10.375H13.125C13.3317 10.375 13.5 10.5432 13.5 10.75V11.5625H14.0345C14.1676 11.5625 14.2921 11.634 14.359 11.7493C14.4258 11.8644 14.4264 12.0079 14.3603 12.1235Z",
    fill: "#343434"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5004 15.7437L10.4938 15.7503H10.5004V15.7437Z",
    fill: "#FF9A30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2504 9.62529V9.61865L14.2438 9.62529H14.2504Z",
    fill: "#FF9A30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8839 5.53038L8.96963 0.616125C8.73363 0.380125 8.41962 0.25 8.08587 0.25H3C2.31075 0.25 1.75 0.81075 1.75 1.5V14.5C1.75 15.1892 2.31075 15.75 3 15.75H10.4937L9.99375 15.25H3C2.58637 15.25 2.25 14.9136 2.25 14.5V1.5C2.25 1.08637 2.58637 0.75 3 0.75H8.08587C8.28625 0.75 8.4745 0.828 8.61613 0.969625L13.5304 5.88387C13.6699 6.0235 13.75 6.21675 13.75 6.41412V9.11875L14.25 9.61875V6.41412C14.25 6.08037 14.12 5.7665 13.8839 5.53038Z",
    fill: "#343434"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2437 9.6249L14.25 9.61865L13.75 9.11865",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.47948d0187e514d719acdee33802c690.svg";
export { ForwardRef as ReactComponent };